/**
 * Whether the study's forms list says the caller may not enter data on the form (`FormModel.mayEnterData`). A Manage
 * forms holder lists every form and may enter data on only some (users decision 23). Unset counts as allowed.
 */
export const refusesEntry = (form: { mayEnterData?: boolean }) => form.mayEnterData === false;
